// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__-B9Jq","body":"Summary_body__XTT9t","content":"Summary_content__xU9Xy","note":"Summary_note__GZhKp","stronk":"Summary_stronk__vL-l-"};